import { PublicClientApplication, LogLevel } from '@azure/msal-browser';
import logger from 'Services/MyTuiProfileCustomLogger';

/**
 * MSAL Configuration for MyTuiProfile Web
 * Follows unified TPP web application patterns
 */
export const msalConfig = {
  auth: {
    clientId: '62c26f28-0ccc-4082-ba5b-eb68497677df',
    authority: 'https://login.microsoftonline.com/e3e1f65b-b973-440d-b61c-bc895fc98e28',
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
    secureCookies: true,
    claimsBasedCachingEnabled: true,
  },
  system: {
    allowNativeBroker: false,
    windowHashTimeout: 60000,
    iframeHashTimeout: 10000,
    loadFrameTimeout: 10000,
    asyncPopups: false,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            logger.error('MSAL Error', new Error(message), { service: 'MSAL' });
            break;
          case LogLevel.Warning:
            logger.warn('MSAL Warning', { message, service: 'MSAL' });
            break;
          default:
            break;
        }
      },
    },
  },
};

/**
 * Login Request Configuration
 */
export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
  extraScopesToConsent: [],
};

/**
 * Token Request Configuration
 */
export const tokenRequest = {
  scopes: ['openid', 'profile', 'email'],
  extraScopesToConsent: [],
};

/**
 * Graph API Request Configuration
 */
export const graphRequest = {
  scopes: ['User.Read'],
};

/**
 * MSAL Instance
 */
export const msalInstance = new PublicClientApplication(msalConfig);

/**
 * Initialize MSAL (will be called in index.js)
 */
export const initializeMsal = async () => {
  await msalInstance.initialize();
};
